import { BankDataDto } from '@app/data/dtos/ptrab/payslips/bank-data.dto';
import { CarTransferDto } from '@app/data/dtos/ptrab/payslips/car-transer.dto';
import { DirectDebitAccountDto } from '@app/data/dtos/ptrab/payslips/direct-debit-account.dto';
import { DirectDebitDto } from '@app/data/dtos/ptrab/payslips/direct-debit.dto';
import { GarnishmentDto } from '@app/data/dtos/ptrab/payslips/garnishment.dto';
import { PayslipDto } from '@app/data/dtos/ptrab/payslips/payslip.dto';
import { UpdateDirectDebitDto } from '@app/data/dtos/ptrab/payslips/update-direct-debit.dto';
import { GarnishmentStatus } from '@app/entities/enums/ptrab/garnishment-status.enum';
import { IDataObjectResponse, IDataResponse } from '@app/entities/interfaces/data/data.interface';
import { BankData } from '@app/entities/models/ptrab/payslips/bank-data.model';
import { CarTransfer } from '@app/entities/models/ptrab/payslips/car-transfer.model';
import { DirectDebitAccount } from '@app/entities/models/ptrab/payslips/direct-debit-account.model';
import { DirectDebit } from '@app/entities/models/ptrab/payslips/direct-debit.model';
import { Garnishment } from '@app/entities/models/ptrab/payslips/garnishment.model';
import { Payslip } from '@app/entities/models/ptrab/payslips/payslip.model';

import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

export const mapPayslip: MapFromFn<PayslipDto, Payslip> = (value) =>
  Builder.forModel(Payslip)
    .id(value.id)
    .type(value.type)
    .company(value.company)
    .isBonus(value.is_bonus)
    .startDate(value.start_date)
    .endDate(value.end_date)
    .build();

export const mapPayslipData: MapFromFn<IDataResponse<PayslipDto[]>, Payslip[]> = (value) => value.data.map(mapPayslip);

export const mapGarnishment: MapFromFn<GarnishmentDto, Garnishment> = (value) =>
  Builder.forModel(Garnishment)
    .balance(value.balance_outstanding)
    .date(value.closing_date)
    .garnishor(value.garnishor)
    .amount(value.total_amount)
    .status(value.status as GarnishmentStatus)
    .id(value.seizure_id)
    .build();

export const mapGarnishmentData: MapFromFn<IDataResponse<GarnishmentDto[]>, Garnishment[]> = (value) =>
  value.data.map(mapGarnishment);

export const mapCarTranfer: MapFromFn<CarTransferDto, CarTransfer> = (value) =>
  Builder.forModel(CarTransfer).id(value.id).company(value.company).type(value.type).endDate(value.date).build();

export const mapCarTransferData: MapFromFn<IDataResponse<CarTransferDto[]>, CarTransfer[]> = (value) =>
  value.data.map(mapCarTranfer);

export const mapAccount: MapFromFn<DirectDebitAccountDto, DirectDebitAccount> = (value) =>
  Builder.forModel(DirectDebitAccount).type(value.type).numberAccount(value.number).bankName(value.bank_name).build();

export const mapDirectDebit: MapFromFn<DirectDebitDto, DirectDebit> = (value) =>
  Builder.forModel(DirectDebit)
    .account(mapAccount(value.account))
    .code(value.code)
    .companyName(value.company_description)
    .employeeNumber(value.employee_number)
    .build();

export const mapUpdateDirectDebit: MapFromFn<DirectDebit, UpdateDirectDebitDto> = (
  value: DirectDebit
): UpdateDirectDebitDto =>
  Builder.forDto<UpdateDirectDebitDto>()
    .company_code(value.code)
    .employee_number(value.employeeNumber)
    .bank_account(value.account?.numberAccount)
    .build();

export const mapDirectDebitData: MapFromFn<IDataObjectResponse<DirectDebitDto[], 'companies'>, DirectDebit[]> = (
  value
) => value.data.companies.map(mapDirectDebit);

export const mapBankData: MapFromFn<BankDataDto, BankData> = (value) =>
  Builder.forModel(BankData).bankName(value.bank_name).build();
